import React from 'react';
import { SectionWrapper } from '../common';
import { processSteps } from '../../data/process';

const styles = {
  timeline: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '24px',
    marginBottom: '48px',
    flexWrap: 'wrap',
  },
  line: {
    position: 'absolute',
    top: '28px',
    left: '5%',
    right: '5%',
    height: '2px',
    background: 'linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4)',
    zIndex: 0,
  },
  step: {
    flex: '1',
    minWidth: '280px',
    position: 'relative',
    zIndex: 1,
  },
  number: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: '700',
    color: '#fff',
    marginBottom: '20px',
    fontFamily: "'Space Grotesk', sans-serif",
  },
  content: {
    backgroundColor: 'rgba(15, 23, 42, 0.6)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    padding: '24px',
  },
  phase: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#3b82f6',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
    margin: '8px 0 16px',
  },
  items: {
    listStyle: 'none',
  },
  item: {
    fontSize: '14px',
    color: '#94a3b8',
    marginBottom: '8px',
    paddingLeft: '16px',
    position: 'relative',
  },
  priceBox: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '24px',
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    border: '1px solid rgba(59, 130, 246, 0.2)',
    borderRadius: '12px',
    padding: '20px 32px',
  },
  priceLabel: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#e2e8f0',
  },
  priceValue: {
    fontSize: '24px',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#3b82f6',
  },
};

export const Process = ({ isVisible }) => {
  return (
    <SectionWrapper
      id="proces"
      label="90-dagen programma"
      title="Zo starten we"
      subtitle="Van onbetrouwbaar CRM naar stabiele basis"
      isVisible={isVisible}
    >
      <div style={styles.timeline}>
        <div style={styles.line} />
        {processSteps.map((step, i) => (
          <div key={i} style={styles.step}>
            <div style={styles.number}>{i + 1}</div>
            <div style={styles.content}>
              <span style={styles.phase}>{step.phase}</span>
              <h4 style={styles.title}>{step.title}</h4>
              <ul style={styles.items}>
                {step.items.map((item, j) => (
                  <li key={j} style={styles.item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <div style={styles.priceBox}>
        <span style={styles.priceLabel}>CRM Reset Programma</span>
        <span style={styles.priceValue}>€2.500 – €4.000</span>
      </div>
    </SectionWrapper>
  );
};
